export default __webpack_public_path__ + "static/media/rocket.82b83ee1.svg";